<template>
  <div class="change-password">
    <div class="panel">
      <div class="form">
        <el-form
          ref="updatePSRef"
          :rules="rules"
          status-icon
          :model="updatePSForm"
          label-width="80px"
        >
          <el-form-item label="旧密码" prop="passold">
            <el-input
              v-model="updatePSForm.passold"
              type="password"
              autocomplete="off"
              show-password
              placeholder="请输入旧密码"
            />
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input
              v-model="updatePSForm.pass"
              type="password"
              autocomplete="off"
              show-password
              placeholder="请输入新密码"
            />
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              v-model="updatePSForm.checkPass"
              type="password"
              autocomplete="off"
              show-password
              placeholder="请输入新密码"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button
          class="btn cancel-btn"
          @click="cancelChange"
        >取 消</el-button>
        <el-button
          type="primary"
          class="btn save-btn"
          @click.enter.native="saveNewPass"
        >保 存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { clearLoginInfo } from '@/utils'
import { changePassword } from '@/api/login'

export default {
  data () {
    const reg = /^[0-9A-Za-z]+$/

    var validatePassOld = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        if (!reg.test(value)) {
          callback(new Error('必须是数字、英文字母'))
        } else if (value.length > 20 || value.length < 6) {
          callback(new Error('长度在 6 到 20 '))
        } else {
          callback()
        }
      }, 700)
    }

    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        if (!reg.test(value)) {
          callback(new Error('必须是数字、英文字母'))
        } else if (value.length > 20 || value.length < 6) {
          callback(new Error('长度在 6 到 20 '))
        } else {
          if (this.updatePSForm.checkPass !== '') {
            this.$refs.updatePSRef.validateField('checkPass')
          }
          callback()
        }
      }, 700)
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      setTimeout(() => {
        if (!reg.test(value)) {
          callback(new Error('必须是数字、英文字母'))
        } else if (value !== this.updatePSForm.pass) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }, 700)
    }
    return {
      updatePSForm: { passold: '', pass: '', checkPass: '' },
      rules: {
        passold: [{ validator: validatePassOld, trigger: 'blur' }],
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  computed: {
    isclick () {
      const { type = '' } = this.$route.query
      return type === 'click'
    }
  },
  mounted () {
    console.log('this.$cookie', this.$cookie)
  },
  methods: {
    cancelChange () {
      this.$emit('close')
    },
    saveNewPass () {
      this.$refs['updatePSRef'].validate((valid) => {
        if (valid) {
          changePassword({
            password: this.updatePSForm.passold,
            newPassword: this.updatePSForm.pass
          })
            .then((res) => {
              if (!res) {
                this.$message({
                  message: '密码更新成功，请重新登录',
                  type: 'success'
                })
              }
              clearLoginInfo()
              this.$cookie.delete('Authorization')
              this.$router.replace({
                path: '/login'
              })
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .change-password {

    display: flex;
    justify-content: center;
    .panel {
      width: 600px;
      height: 365px;

      padding: 20px 30px 0px 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .note {
        display: flex;
        align-items: center;
        & > img {
          width: 20px;
        }
        & > span {
          font-size: 14px;
          font-family: MiSans;
          font-weight: 400;
          color: #F33458;
          margin-left: 20px;
        }
      }
      .title {
        font-size: 20px;
        font-weight: 600;
      }
      .form {
        width: 100%;
        ::v-deep .el-form-item {
          margin-bottom: 40px;
        }
      }
      .footer {
        .btn {
          font-size:16px;
        }
        .cancel-btn {
          background: #A1A8B2;
          color: #fff;
        }
        .save-btn {
          margin-left: 40px;
        }
      }
    }
  }
</style>
